document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var closeBtn = document.querySelector('.menu-close');

  if (!toggle || !mobileMenu) return;

  function openMenu() {
    mobileMenu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    // move focus into menu
    var focusable = mobileMenu.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
    document.documentElement.classList.add('mobile-menu-open');
  }

  function closeMenu() {
    mobileMenu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
    document.documentElement.classList.remove('mobile-menu-open');
  }

  toggle.addEventListener('click', function (e) {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    if (expanded) closeMenu();
    else openMenu();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  // close when clicking backdrop
  mobileMenu.addEventListener('click', function (e) {
    if (e.target === mobileMenu) closeMenu();
  });

  // ESC to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !mobileMenu.hidden) closeMenu();
  });
});
